<!--<p>mapa-inmaterial works!</p>-->
<div id="hotel_map">
  <span id="btn-toc-map" (click)="toggleTocMap()">{{ viewTocMap === true ? '&laquo;' : '&raquo;' }}</span>
  <div id="layertree" [ngClass]="[ viewTocMap ? 'tocMostrar' : 'tocOcultar']">
    <h5>Capas</h5>
    <ul>
      <li><span>OSM </span>
        <fieldset id="layer0">
          <label class="checkbox" for="visible0">
            visibilidad <input id="visible0" class="visible" type="checkbox" />
          </label>
          <label>
            opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
          </label>
        </fieldset>
      </li>
      <li><span>Google Map Híbrido</span>
        <fieldset id="layer1">
          <label class="checkbox" for="visible1">
            visibilidad <input id="visible1" class="visible" type="checkbox" />
          </label>
          <label>
            opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
          </label>
        </fieldset>
      </li>
      <li>
        <span>Base</span>
        <fieldset id="layer2">
          <label class="checkbox" for="visible1">
            visibilidd <input id="visible2" class="visible" type="checkbox" />
          </label>
          <label>
            opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
          </label>
        </fieldset>
        <ul>
          <li>
            <span class="item-title">Borde ACP CHC</span>
            <fieldset id="layer20">
              <label class="checkbox" for="visible20">
                visibilidad <input id="visible20" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Borde CHC</span>
            <fieldset id="layer21">
              <label class="checkbox" for="visible21">
                visibilidad <input id="visible21" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Sectores CHC</span>
            <fieldset id="layer22">
              <label class="checkbox" for="visible22">
                visibilidad <input id="visible22" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Inmuebles</span>
            <fieldset id="layer23">
              <label class="checkbox" for="visible23">
                <span class="item-label">visible</span> <input id="visible23" class="visible" type="checkbox" />
              </label>
              <label>
                <span class="item-label">opacidad</span> <input class="opacity" type="range" min="0" max="1"
                  step="0.01" />
              </label>
            </fieldset>
          </li>
          <li>
            <span class="item-title">Patrimonio Inmaterial</span>
            <fieldset id="layer24">
              <label class="checkbox" for="visible24">
                visible <input id="visible24" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>
          <!--<li>
            <span class="item-title">Patrimonio Inmaterial2</span>
            <fieldset id="layer24">
              <label class="checkbox" for="visible24">
                visible <input id="visible24" class="visible" type="checkbox" />
              </label>
              <label>
                opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
              </label>
            </fieldset>
          </li>-->
          <!--<li>
              <span class="item-title">Sectores Nombres CHC</span>
              <fieldset id="layer23">
                <label class="checkbox" for="visible13">
                  visible <input id="visible11" class="visible" type="checkbox" />
                </label>
                <label>
                  opacidad <input class="opacity" type="range" min="0" max="1" step="0.01" />
                </label>
              </fieldset>
            </li>
            <li>
              <span class="item-title">Inmuebles</span>
              <fieldset id="layer24">
                <label class="checkbox" for="visible11">
                  <span class="item-label">visible</span> <input id="visible11" class="visible" type="checkbox" />
                </label>
                <label>
                  <span class="item-label">opacidad</span> <input class="opacity" type="range" min="0" max="1"
                    step="0.01" />
                </label>
              </fieldset>
            </li>-->
        </ul>
      </li>
    </ul>

  </div>
</div>

<!--<div class="ol-popup">
    <a href="#" id="popup-closer" class="ol-popup-closer"></a>
    <div id="popup-content"></div>
  </div>-->
<!-- convertir a Angular COMPONENT-->
<!--<div id="popup" class="ol-popup">{{ infoElemento | json}}</div>-->
<!-- -->

<!-- POPOP PEFERCT !!!
  <div id="popup" class="ol-popup">
    <a href="#" id="popup-closer" class="ol-popup-closer"></a>
    <div *ngIf="infoElemento">
      <p class="item-line-pop-up"><img
          src="http://172.16.7.144/registrofotografico/{{infoElemento.codigo_registro | slice : 0 : 10 }}/arquitectonica/F21.jpg"
          width=300></p>
      <p class="item-line-pop-up">Nro. Ficha: <b><a>{{infoElemento.codigo_registro}}</a></b> </p>
      <p class="item-line-pop-up">Reg. Foto: <b><a>{{infoElemento.cod_lote}}</a></b> </p>
      <p class="item-line-pop-up">Cat. Catalog.: <b><a>{{infoElemento.nombre}}</a></b> </p>
      <p class="item-line-pop-up">Zonific.: <b><a>{{infoElemento.oficio}}</a></b> </p>
      <p class="item-line-pop-up">Reg. Foto: <b><a routerLink="kiki">{{infoElemento.cod_lote}}</a></b> </p>
      <button class="btn btn-primary btn-sm" (click)="verFicha()">ver</button>
    </div>
  </div>-->

<div id="popup" class="ol-popup">
  <!--Habilitar CERRAR PopUP    -->
  <a href="#" id="popup-closer" class="ol-popup-closer"></a>
  <div *ngIf="infoElementoPuntos">
    <p class="text-center">{{infoElementoPuntos.nombre_manifestacion}}</p>
    <img src="assets/img/secciones/inmaterial/{{infoElementoPuntos.codregistro}}.jpg" class="img-fluid" />
    <!--<p>{{infoElementoPuntos.codregistro}}</p>-->
    <button class="btn btn-primary btn-sm btn-01-color-gchc btn-block"
      (click)="cargarCatFichaInmaterialPorCodregistro(infoElementoPuntos.codregistro)"><i class="fa fa-eye mx-1"
        aria-hidden="true"></i> ver más</button>
    <button class="btn btn-lg btn-outline-primary"
      (click)="cargarCatFichaInmaterialPorCodregistro(infoElementoPuntos.codregistro)">Launch demo modal</button>
  </div>
</div>


<!---->
<div id="info"></div>
<!-- PRUEBA -->
<!--<div id="prueba" *ngIf="infoElemento">
    <li>{{ infoElemento.cod_catalo }}</li>
  </div>-->

  <div class="container" *ngIf="catFichaInmaterial" id="info_cat_ficha_inmaterial">
    <div class="row text-white">
      <div class="col-md-6 col-sm-12">
        <img src="assets/img/secciones/inmaterial/{{catFichaInmaterial.codregistro}}.jpg" class="img-fluid"/>
        <i class="fas fa-map-marker-alt"></i>
      </div>
      <div class="col-md-6 col-sm-12">
        <div class="titulo-item"><i class="fa fa-map-marker mx-1" aria-hidden="true"></i>Ubicación / Vinculo </div>
        <div class="item">{{catFichaInmaterial.ubicacion_manifestacion}}</div>
        <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Manifestación </div>
        <div class="item">{{catFichaInmaterial.nombre_manifestacion}}</div>
        <div class="titulo-item"><i class="fa fa-user-circle-o mx-1" aria-hidden="true"></i>Nombre del Reresentante </div>
        <div class="item">{{catFichaInmaterial.nombre_representante}}</div>
        
        <div class="seccion-item">Manifestación de Herencia</div>
        
        <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Manifestación de Herencia </div>
        <div class="item">{{catFichaInmaterial.mh_manifestacion_herencia}}</div>
        <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Año de referencia </div>
        <div class="item">{{catFichaInmaterial.mh_agno_ref_expresion_cultural}}</div>
        <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Tipo de Manifestación </div>
        <div class="item">{{catFichaInmaterial.mh_titulo}}</div>
        <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Descripción </div>
        <div class="item" [innerHTML]="catFichaInmaterial.mh_descripcion"></div>
      </div>
    </div>
    <div class="row text-white">
      <div class="col-md-12 col-sm-12">
        <div>
          <div class="seccion-item">Marco Temporaral</div>
    
          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Marco Temporal </div>
          <div class="item">{{catFichaInmaterial.mt_marco_temporal}}</div>
          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Fecha </div>
          <div class="item">{{catFichaInmaterial.mt_fecha_celebracion}}</div>
          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Descripción </div>
          <div class="item" [innerHTML]="catFichaInmaterial.mt_desc_obs"></div>
        </div>
        <div>
          <div class="seccion-item">Tema</div>

          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Tema </div>
          <div class="item">{{catFichaInmaterial.tm_tema}}</div>
          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Descripción </div>
          <div class="item" [innerHTML]="catFichaInmaterial.tm_desc_obs"></div>
        </div>
        <div>
          <div class="seccion-item">Estado Actual</div>

          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Estado Actual </div>
          <div class="item">{{catFichaInmaterial.ea_estado_actual}}</div>
          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Descripción </div>
          <div class="item" [innerHTML]="catFichaInmaterial.ea_desc_obs"></div>
        </div>
        <div>
          <div class="seccion-item">Trascendencia Cultural</div>

          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Trascendencia Cultural </div>
          <div class="item">{{catFichaInmaterial.tca_trasc_cultural_alcance}}</div>
          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>Descripción </div>
          <div class="item" [innerHTML]="catFichaInmaterial.tca_desc_obs"></div>
        </div>
        <div>
          <div class="seccion-item">Registro de Elementos o Procesos destacables</div>
          
          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>{{catFichaInmaterial.roepd1_element_destacables}} </div>
          <div class="item" [innerHTML]="catFichaInmaterial.roepd1_desc_obs"></div>
          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>{{catFichaInmaterial.roepd2_element_destacables}} </div>
          <div class="item" [innerHTML]="catFichaInmaterial.roepd2_desc_obs"></div>
          <div class="titulo-item"><i class="fa fa-check-circle-o mx-1" aria-hidden="true"></i>{{catFichaInmaterial.roepd3_element_destacables}} </div>
          <div class="item" [innerHTML]="catFichaInmaterial.roepd3_desc_obs"></div>
        </div>
        <div>
          <div class="seccion-item">Información adicional</div>

          <div class="item" [innerHTML]="catFichaInmaterial.observaciones"></div>

          <div class="seccion-item">Fecha (información) : {{catFichaInmaterial.fecha}}</div>

        </div>  
      </div>
    </div>
    
  </div>
  